import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ProductsProvider } from './context/ProductsContext';
import { PublicSettingsProvider } from './context/PublicSettingsContext';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ProductsProvider>
        <PublicSettingsProvider>
          <App />
        </PublicSettingsProvider>
      </ProductsProvider>
    </BrowserRouter>
  </React.StrictMode>
);
